import React from "react";

export interface HeaderInfo {
    street?: string;
    cityStateZip?: string;
    county?: string;
    id?: string | number;
    description?: string;
    submissionStatus?: string
}

const HeaderInfoBarRenderer: React.FC<{ headerInfo: HeaderInfo }> = ({ headerInfo }) => {
    const street = headerInfo.street?.trim();
    const cityStateZip = headerInfo.cityStateZip?.trim();
    const county = headerInfo.county?.trim();
    const description = headerInfo.description?.trim();
    const id = headerInfo.id;

    const parts = [
        street,
        cityStateZip,
        county ? `${county} County` : null,
        description,
        id ? `${id}` : null,
    ].filter(Boolean);

    if (!parts.length) {
        return null;
    }

    return (
        <div className="flex items-center gap-2 rounded-md bg-white/80 border border-slate-200 px-4 py-2 shadow-sm">
            <div className="min-w-0 flex-1 flex items-center gap-2.5 text-base text-slate-700 truncate">
                {parts.map((part, index) => (
                    <React.Fragment key={index}>
                        {index > 0 && (
                            <span className="text-slate-400">•</span>
                        )}
                        <span className={`truncate ${index === 0 ? "font-semibold text-slate-900" : ""}`}>
                            {part}
                        </span>
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};


const areHeaderInfoEqual = (prev: { headerInfo: HeaderInfo }, next: { headerInfo: HeaderInfo }) => {
    const a = prev.headerInfo;
    const b = next.headerInfo;

    return (
        a.id === b.id
    );
};

export const HeaderInfoBar = React.memo(HeaderInfoBarRenderer, areHeaderInfoEqual);
